module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue5.f491229c.jpg";